import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=f8cf20a2&scoped=true&"
import script from "./versions.vue?vue&type=script&lang=js&"
export * from "./versions.vue?vue&type=script&lang=js&"
import style0 from "./versions.vue?vue&type=style&index=0&id=f8cf20a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf20a2",
  null
  
)

export default component.exports